import { forwardRef } from 'react';

const Card = forwardRef(function Card(
  { className = '', interactive = false, padded = true, children, ...props },
  ref
) {
  return (
    <div
      ref={ref}
      className={`
        bg-[var(--color-cream-50)]
        border border-[var(--color-warm-100)]
        rounded-[var(--radius-lg)]
        shadow-[var(--shadow-xs)]
        ${interactive ? 'hover:shadow-[var(--shadow-md)] hover:border-[var(--color-warm-200)] transition-all duration-200 cursor-pointer' : ''}
        ${padded ? 'p-5' : ''}
        ${className}
      `}
      {...props}
    >
      {children}
    </div>
  );
});

export function CardHeader({ title, description, action, className = '' }) {
  return (
    <div className={`flex items-start justify-between gap-4 mb-4 ${className}`}>
      <div className="min-w-0 flex-1">
        <h3 className="text-[15px] font-semibold text-[var(--color-warm-900)] leading-tight tracking-tight">
          {title}
        </h3>
        {description && (
          <p className="text-[13px] text-[var(--color-warm-500)] mt-1">
            {description}
          </p>
        )}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}

export default Card;
